<script>
  // svelte
  import { getContext } from 'svelte'
  
  let stores = getContext('trustStores')
  let swapReversed = stores.swapReversed
  
  $swapReversed = false
</script>